import React, { useCallback } from "react";
import { Button } from "src/components/elements/button/Button";
import { Text } from "src/components/elements/typography/Text";
import { NewsItem } from "src/modules/domain/notification/NewsItem";
import { getLocalStorage, setLocalStorage } from "src/modules/localStorage";
import styles from "./styles.module.css";
import { NewsItemTitleListProps } from "./types";

export const NewsItemTitleList = React.memo(
  ({ newsItemList, setSelectedNewsId }: NewsItemTitleListProps) => {
    const renderNewsItemTitle = useCallback(
      (newsItem: NewsItem) => {
        const title = newsItem.title;
        const subtitle = newsItem.start_datetime;

        const readNewsString = getLocalStorage<string>("readNews");
        const unreadNewsString = getLocalStorage<string>("unreadNews");

        const readNews: number[] = readNewsString.isStored
          ? JSON.parse(readNewsString.value)
          : [];
        const unreadNews: number[] = unreadNewsString.isStored
          ? JSON.parse(unreadNewsString.value)
          : [];

        const textColor = readNews.includes(newsItem.id)
          ? "light-gray"
          : "black";

        const handleClick = () => {
          if (unreadNews.includes(newsItem.id)) {
            const updatedUnreadNews = unreadNews.filter(
              (id) => id !== newsItem.id
            );

            if (!readNews.includes(newsItem.id)) {
              readNews.push(newsItem.id);
            }

            const updatedReadNewsString = JSON.stringify(readNews);
            const updatedUnreadNewsString = JSON.stringify(updatedUnreadNews);

            setLocalStorage("readNews", updatedReadNewsString);
            setLocalStorage("unreadNews", updatedUnreadNewsString);
          }
          setSelectedNewsId(newsItem.id);
        };

        return (
          <Button
            buttonType="buttonColorFrameless"
            borderRadius="border-radius-0"
            buttonContainerClassName={styles.titleButton}
            onClick={handleClick}
          >
            <div className={styles.titleTextContainer}>
              <Text
                size="size-16"
                className={styles.titleText}
                color={textColor}
              >
                {title}
              </Text>
              <Text size="size-12" color={textColor}>
                {subtitle}
              </Text>
            </div>
          </Button>
        );
      },
      [setSelectedNewsId]
    );

    if (newsItemList.length === 0) {
      return <Text>お知らせはありません</Text>;
    }

    return (
      <div className={styles.nonEmptyTitleListContainer}>
        {newsItemList.map((newsItem) => (
          <React.Fragment key={newsItem.id}>
            {renderNewsItemTitle(newsItem)}
          </React.Fragment>
        ))}
      </div>
    );
  }
);
